'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UserConfig = exports.UserConfig = function UserConfig($stateProvider) {
  'ngInject';

  $stateProvider.state('app.userListing', {
    url: '^/users',
    template: '<users-listing></users-listing>'
  });
  $stateProvider.state('app.userView', {
    url: '^/user-details-view/:id',
    template: '<user-view></user-view>'
  });
};

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/users/components/user.config.js
 **/